export default "__VITE_ASSET__1deef8c6__"